import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { FormattedDate } from 'components/intl'
import { Table, Data } from 'components/layout/Table'
import { ajEvents as ajEventsLayout } from 'constants/layout'
import { Export } from 'containers/misc'
import { Span } from 'components/layout'
import config from 'config'

export default class AjEventsTable extends Component {
  static propTypes = {
    setAjEventsParams: PropTypes.func.isRequired,
    exportAjEvents: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    offset: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    sort: PropTypes.string.isRequired,
    list: PropTypes.array.isRequired,
    setCommonLimit: PropTypes.func,
    ajEvents: PropTypes.object
  }

  render() {
    const {
      list,
      loading,
      offset,
      limit,
      pages,
      sort,
      setAjEventsParams,
      setCommonLimit
    } = this.props
    const exportComponent = (
      <Export
        exportName="Aj events"
        toExport={this.props.exportAjEvents}
        exportSchemeValue="aj-events"
        count={this.props.ajEvents && this.props.ajEvents.count}
      />
    )

    return (
      <Table
        loading={loading}
        length={list.length}
        offset={offset}
        limit={limit}
        onSetLimit={setCommonLimit}
        sort={sort}
        pages={pages}
        ths={ajEventsLayout.tableHeaders}
        setParams={setAjEventsParams}
        exportComponent={exportComponent}
      >
        <Data>
          {list.map((item, index) => (
            <tr key={index}>
              <td>
                <Link to={`${config.publicPath}/adventurous-journeys/${item.id}/detail`}>
                  {item.id}
                </Link>
              </td>
              <td>
                <Span style={{ maxWidth: '160px' }} textOverflow>
                  {get(item, 'title') || '---'}
                </Span>
              </td>
              <td>{get(item, 'ajEventCategory.translationText')}</td>
              <td>{get(item, 'activityCategory.translatedName')}</td>
              <td>{get(item, 'activityCategory.parent.translatedName')}</td>
              <td>{get(item, 'awardLevel.translationText')}</td>
              <td>{get(item, 'organization.name')}</td>
              <td>
                {item.startDate
                  ? <FormattedDate value={item.startDate}/>
                  : '---'}
              </td>
              <td>
                {item.endDate ? <FormattedDate value={item.endDate}/> : '---'}
              </td>
              <td>
                {get(item, 'createdByPerson.firstName')}{' '}
                {get(item, 'createdByPerson.lastName')}
              </td>
              <td className="text--center">{get(item, 'participantsCount')}</td>
            </tr>
          ))}
        </Data>
      </Table>
    )
  }
}
